<template>
        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true"  :static="true" :title="caption" v-model="dataShow" :ok-disabled="dataConfirmDisabled" @ok="confirm" :ok-title="Core.Definition.getDefinition('Confirmer')" :ok-variant="okVariant" :cancel-title="Core.Definition.getDefinition('Annuler')" cancel-variant="light">
            <b-alert :variant="alertVariant" v-if="messageInAlert" show>{{message}}</b-alert>
            <div v-if="!messageInAlert">{{message}}</div>
            <slot name="body"></slot>
        </b-modal>
</template>

<script>
  export default {
      name: 'ModalConfirm',
      components: {
      },
      props: {
          caption: {
              type: String,
              default: ''
          },
          okVariant: {
              type: String,
              default: 'success'
          },
          alertVariant: {
              type: String,
              default: ''
          },
          message: {
              type: String,
              default: ''
          },
          closeOnConfirm: {
              type: Boolean,
              default: true
          },
          messageInAlert: {
              type: Boolean,
              default: false
          }
      },
      watch: {
      },
      mounted() {
      },
      data: () => {
          return {
              Core: window.Core,
              dataShow: false,
              dataConfirmDisabled: false
          }
      },
      computed: {
          open: {
              set(val) {
                  this.dataShow = val
              },
              get() {
                  return this.dataShow
              }
          },
          disableConfirm: {
              set(val) {
                  this.dataConfirmDisabled = val
              },
              get() {
                  return this.dataConfirmDisabled
              }
          }
      },
      methods: {
          confirm(e) {
              e.preventDefault()
              this.$emit('onConfirm')
              if (this.closeOnConfirm) {
                  this.open = false
              }
          }
      }
  }
</script>